import {FunctionField} from "react-admin";
import {useCallback} from "react";
import {Checkbox} from "@material-ui/core";

interface ReconciliationSelectFieldProps {
  selectedRow: any[];
  setSelectedRow: React.Dispatch<React.SetStateAction<any[]>>;
}

export const ReconciliationSelectField = ({
  selectedRow,
  setSelectedRow,
}: ReconciliationSelectFieldProps) => {
  
  const handleToggle = useCallback((tableRecord: any) => {
    if (!tableRecord || !tableRecord.id) return;

    setSelectedRow(prevSelected => {
      const isSelected = prevSelected.some(item => item === tableRecord.id);
      return isSelected 
        ? prevSelected.filter(id => id !== tableRecord.id)
        : [...prevSelected, tableRecord.id];
    });
  }, [setSelectedRow]);

  return (
    <FunctionField
      label=""
      render={(tableRecord: any) => {
        const isSelected = selectedRow.some(id => id === tableRecord.id);
        return (
          <Checkbox
            checked={isSelected}
            onChange={() => handleToggle(tableRecord)}
            inputProps={{ 'aria-label': 'seleziona riga' }}
          />
        );
      }}
    />
  );
};